import News from '../news.js';
/**
 * Create the action
 */

const { thunk, request, success, error } = News.index((fetch) =>
    fetch.get('news')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
